angular.module("UI8.services").service("ShotService", [
  "$http",
  "$window",
  function ($http, $window) {
    /**
     * Paginated shots feed
     */
    this.list = function (params) {
      params = params || {};
      var url =
        "/api/shots?page=" +
        (params.page || 1) +
        "&sort=" +
        (params.sort || "recent") +
        (params.tag ? "&tag=" + encodeURIComponent(params.tag) : "");

      return $http
        .get(url)
        .then(function (res) {
          return res.data;
        })
        .catch(function () {
          return { shots: [], meta: { page: 1, pages: 1, total: 0 } };
        });
    };

    /**
     * A user's published shots (profile Work tab)
     */
    this.listByUser = function (key, page) {
      return $http
        .get("/api/shots/user/" + key + "?page=" + (page || 1))
        .then(function (res) {
          return res.data;
        })
        .catch(function () {
          return { shots: [], meta: { page: 1, pages: 1, total: 0 } };
        });
    };

    /**
     * Single shot (composer edit prefill)
     */
    this.get = function (slug) {
      return $http
        .get("/api/shots/" + slug)
        .then(function (res) {
          return res.data;
        })
        .catch(function () {
          return null;
        });
    };

    /**
     * Posting permission + own products for the attach picker
     */
    this.permissions = function () {
      return $http
        .get("/api/shots/permissions")
        .then(function (res) {
          return res.data;
        })
        .catch(function () {
          return { can_post: false, products: [] };
        });
    };

    this.create = function (payload) {
      return $http.post("/api/shots", payload).then(function (res) {
        return res.data;
      });
    };

    this.update = function (id, payload) {
      return $http.put("/api/shots/" + id, payload).then(function (res) {
        return res.data;
      });
    };

    this.remove = function (id) {
      return $http.delete("/api/shots/" + id).then(function (res) {
        return res.data;
      });
    };

    /**
     * Optimistic like toggle; mutates the passed shot object
     */
    this.toggleLike = function (shot) {
      if (!$window.UI8.loggedIn) return;

      if (shot.liked) {
        shot.liked = false;
        shot.likes = Math.max((shot.likes || 1) - 1, 0);
        $http.delete("/account/favorite/" + shot._id + "?json=1&type=shot");
      } else {
        shot.liked = true;
        shot.likes = (shot.likes || 0) + 1;
        $http.put("/account/favorite/" + shot._id + "?json=1&type=shot");
      }
    };
  },
]);
